var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-observer',{ref:"form",scopedSlots:_vm._u([{key:"default",fn:function({ passes, invalid }){return [_c('b-form',_vm._b({on:{"submit":function($event){$event.preventDefault();return passes(_vm.onSubmit)}}},'b-form',_vm.$attrs,false),[_vm._t("form",null,{"invalid":invalid}),_vm._t("buttons",null,{"invalid":invalid})],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }